import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import { getAllRentsByUser } from '../../store/rents/actions';
import KobooDialog from '../Layout/KobooDialog.jsx';
import UserRentTable from './UserRentTable';
import Loader from '../Layout/Loader';
import { getBackOfficeRoute, headers } from '../../services/api/header';
import { ROLE_ADMIN } from '../../constants/roles';
import { getUsers } from '../../store/users/actions';
import { dispatchInfo, handleError } from '../../store/infos/actions';

const INITIAL_STATE = {
  dialog: {
    open_rents: false,
    open_caution: false,
    caution: 0,
  },
  dialogAnonymize: {
    open_delete: false,
  },
  loading: false,
};

export class UserRow extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  static propTypes = {
    user: PropTypes.object.isRequired,
    getAllRentsByUser: PropTypes.func.isRequired,
    dispatchInfo: PropTypes.func.isRequired,
    handleError: PropTypes.func.isRequired,
    open: PropTypes.bool,
    getUsers: PropTypes.func.isRequired,
  };

  // Handler

  handleClose = () => {
    this.setState({ ...INITIAL_STATE });
  };

  handleClickOpenRents = element => {
    if (this.props.authUser && this.props.roles) {
      const role = this.props.roles[this.props.authUser.uid];
      this.props.getAllRentsByUser(this.props.authUser.ma, role, element);
    }
    this.setState({
      dialog: {
        ...this.state.dialog,
        open_rents: true,

      },
    });
  };

  handleClickOpenDialogAnonymize = element => {
    this.setState({
      dialogAnonymize: {
        ...this.state.dialogAnonymize,
        open_delete: true,
      },
    });
  };

  handleClickAnonymize = (event, userId) => {
    event.preventDefault();
    const token = this.props.authUser.ma;
    this.setState({ loading: true });
    return axios
      .delete(
        `${getBackOfficeRoute(ROLE_ADMIN)}/users/${userId}`,
        {
          headers: headers(token),
          params: { force: true },
        },
      )
      .then(
        (res) => {
          this.props.getUsers();
          this.props.dispatchInfo('L\'utilisateur a été anonymisé');
        })
      .catch((error) => {
        this.props.handleError({ message: 'Une erreur est survenue lors de l\'anonymisation de l\'utilisateur' });
      })
      .finally(() => {
        this.setState(INITIAL_STATE);
      });
  };

  render() {
    const {
      user,
      rents,
      pending,
    } = this.props;

    return (
      <TableRow
        key={user.id}
        hover
        tabIndex={-1}
      >
        <KobooDialog
          id="dialog_user_rents"
          open={this.state.dialog.open_rents}
          handleClose={this.handleClose}
          dialogTitle={`Liste des locations`}
          handleCloseCancel={this.handleClose}
          textField={!rents && !pending
            ? ''
            :
            pending
              ? <Loader />
              : <UserRentTable
                rents={rents.rents}
              />
          }
          cancelText="OK"
        />
        <KobooDialog
          open={this.state.dialogAnonymize.open_delete}
          handleClose={this.handleClose}
          dialogTitle={`Anonymisation du compte`}
          handleCloseCancel={this.handleClose}
          cancelText={'Annuler'}
          okText={'Valider'}
          textField={`Vous êtes sur le point d'anonymiser un utilisateur de façon permanente, êtes-vous sûr de vouloir continuer?`}
          handleCloseOK={(event) => this.handleClickAnonymize(event, user.id)}
          loading={this.state.loading}
        />
        <TableCell>{user.lastname}</TableCell>
        <TableCell>{user.firstname}</TableCell>
        <TableCell style={{ wordBreak: 'break-all' }}>{user.email}</TableCell>
        <TableCell>{user.mobile}</TableCell>
        <TableCell>{user.zipCode}</TableCell>
        <TableCell padding="checkbox">
          <Tooltip title="Liste des locations">
            <IconButton onClick={() => this.handleClickOpenRents(user)}>
              <ListIcon color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Anonymiser">
            <IconButton onClick={() => this.handleClickOpenDialogAnonymize()}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = state => (
  {
    roles: state.roles.content,
    pending: state.rents.pending,
    rents: state.rents.contentClients,
  }
);

export default connect(
  mapStateToProps,
  {
    getAllRentsByUser,
    getUsers,
    dispatchInfo,
    handleError,
  },
)(
  UserRow);



// WEBPACK FOOTER //
// ./src/components/Users/UserRow.jsx